import React from 'react'
import PropTypes from 'prop-types'
import * as utils from '../components/common/utils'
import styles from './Hero.module.scss'
// components
import Logo from '../images/svg/logo_happysunny.svg'
import Sunny from '../images/svg/icon_sunny.svg'
import ArrowDown from '../images/svg/icon_arrow-down.svg'

const Hero = () => {
    const moveToNews = () => utils.moveto('news');

    return (
        <section name="home" className={styles.wrapper}>
            <div className={styles.inner}>
                <div className={styles.bg}>
                    <video loop autoplay="true" muted="true" playsinline="true" poster="/images/photo_hero.jpg">
                        <source src="/assets/movie_hero.mp4" type="video/mp4" />
                    </video>
                </div>
                <div className={styles.container}>
                    <div 
                        className={styles.logo}
                        onClick={moveToNews}
                    >
                        <Logo />
                    </div>
                {/* 外部リンクの場合 */}
                {/* <a 
                    className={styles.news}
                    href=""
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    link
                    <ArrowRight />
                </a> */}
                <div 
                    className={styles.news}
                    onClick={moveToNews}
                >
                    業務提携パートナースタッフを募集しています。詳しくはこちら↓
                </div>
                <div 
                    className={styles.scroll}
                    onClick={moveToNews}
                >
                    <Sunny />
                    <ArrowDown />
                </div>
                </div>
            </div>
        </section>
    );
}

export default Hero;
